import React, { Component } from 'react';
import { get } from 'lodash';
import './styles.scss';

export default class CovExclCheckbox extends Component {
  render() {
    const { input, options, objectKey } = this.props;

    return (
      <div>
        <div>
          <div>
            {options.map((option, key) => {
              const value = objectKey ? get(option.value, objectKey) : option.value;
              return (
                <div key={key}>
                  <div className={'covExcl-checkbox'}>
                    <input
                      {...input}
                      type="checkbox"
                      id={input.name + option.label}
                      value={option.value}
                      checked={input.value.toString() === value.toString()}
                    />
                    <label htmlFor={input.name + option.label} />
                  </div>
                  <div
                    className="radio-label"
                    onClick={() => input.onChange(option.value)}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}
